import { NEW_ACTIVITY_EXECUTION_NAMESPACE } from '../reducers/activity-execution'

export const selectProjectDetails = (state: any) =>
    state[NEW_ACTIVITY_EXECUTION_NAMESPACE].projectDetails
